import Card from '../../components/Card'

import * as S from './styles'

const ListaCard = () => {
  return (
    <S.Lista className="container">
      <Card type="info" />
      <Card type="mensage" />
      <Card type="conta" />
      <Card type="modal" />
      <Card type="dowloadImage" />
      <Card type="zoom" />
    </S.Lista>
  )
}

export default ListaCard
